// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"fa198b94","453":"6de0495d","748":"0f66a259"}[chunkId] + ".chunk.js";
};